import Model from "../Apis/Semester";
import Controller from "./Controller";
import axios from "axios";

export default class SemesterController extends Controller {
  constructor() {
    super(new Model());
  }
  async setActive(eduProgramId, id) {
    const res = await this.model.setActive(eduProgramId, id);
    return this.Poup(res);
  }

  async getSemesters() {
    const res = await this.model.getSemesters();
    return res;
  }

  async getSubjects(id) {
    const res = await this.model.getSubjects(id);
    return res;
  }

  async getActivities(semesterCode, subjectCode) {
    try {
      const response = await axios.get(
        `https://dev.furqn.com/subjectplan?subjectCode=${subjectCode}&semesterCode=${semesterCode}`,
        
      );
   
      
      return response.data;
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;
      }
    }
  }
}
